import React, { useEffect, useState } from 'react';
import { InputNumber, message, Modal, Select, Space } from 'antd';
import { batchAuthorize } from '@/api/tenantAuth';
import { getTenantList, TenantListVo } from '@/api/auth';

export interface BatchAuthProp {
  agentId: number;
  updateFn: () => void;
  onCancel: () => void;
}

const BatchAuthModal = ({ agentId, updateFn, onCancel }: BatchAuthProp) => {
  const [selectedTenants, setSelectedTenants] = useState<string[]>([]);
  const [tenantList, setTenantList] = useState<TenantListVo[]>([]);
  const [dailyLimit, setDailyLimit] = useState<number | undefined>();
  const [monthlyLimit, setMonthlyLimit] = useState<number | undefined>();
  const [loading, setLoading] = useState(false);
  const [tenantLoading, setTenantLoading] = useState(false);

  // 加载租户列表
  useEffect(() => {
    setTenantLoading(true);
    getTenantList()
      .then(list => setTenantList(list || []))
      .catch(err => {
        console.error('获取租户列表失败:', err);
        message.error('获取租户列表失败');
      })
      .finally(() => setTenantLoading(false));
  }, []);

  const onFinish = () => {
    if (selectedTenants.length === 0) {
      message.warning('请选择租户');
      return;
    }
    setLoading(true);
    batchAuthorize({ agentId, tenantMcids: selectedTenants, dailyLimit, monthlyLimit })
      .then(() => {
        message.success('批量授权成功');
        onCancel();
        updateFn();
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      title="批量授权租户"
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
      confirmLoading={loading}
    >
      <div style={{ marginBottom: 16 }}>
        <label>租户：</label>
        <Select
          mode="multiple"
          placeholder="请选择租户"
          value={selectedTenants}
          onChange={setSelectedTenants}
          loading={tenantLoading}
          showSearch
          optionFilterProp="label"
          style={{ width: '100%' }}
          options={tenantList.map(t => ({
            value: t.tenantMcid,
            label: t.name,
          }))}
        />
      </div>
      <Space style={{ width: '100%' }}>
        <div>
          <label>每日限制：</label>
          <InputNumber min={1} value={dailyLimit} onChange={v => setDailyLimit(v)} placeholder="无限制" style={{ width: 120 }} />
        </div>
        <div>
          <label>每月限制：</label>
          <InputNumber min={1} value={monthlyLimit} onChange={v => setMonthlyLimit(v)} placeholder="无限制" style={{ width: 120 }} />
        </div>
      </Space>
    </Modal>
  );
};

export default BatchAuthModal;